import React from 'react'
import PropTypes from 'prop-types'

import SearchModuleDestination from '../../modules/SearchModuleDestination';
import SearchModuleRooms from '../../modules/SearchModuleRooms';
import SearchModuleDates from '../../modules/SearchModuleDates';
import SearchModuleSpecialRates from '../../modules/SearchModuleSpecialRates';
import {MODULE_DATES, MODULE_DESTINATION, MODULE_ROOMS, MODULE_SPECIAL_RATES} from '../../constants';

const mapModules = {
  [MODULE_DESTINATION]: SearchModuleDestination,
  [MODULE_ROOMS]: SearchModuleRooms,
  [MODULE_DATES]: SearchModuleDates,
  [MODULE_SPECIAL_RATES]: SearchModuleSpecialRates,
}

const ModuleByKey = function ({info, ...props}) {
  const {module, ...moduleSettings} = typeof info === 'string' ? {module: info} : info;
  const ModuleComponent = mapModules[module];

  return (<ModuleComponent {...props} {...moduleSettings} />)
}

ModuleByKey.propTypes = {
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    module: PropTypes.string,
  })])
}

export default ModuleByKey;
